export default __webpack_public_path__ + "static/media/Cartão de Natal - Opção 04.d73421e5.png";